exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".section-notices-pagination {\n  margin-top: 50px;\n}\n.notices-col {\n  margin-top: 15px;\n}\n", ""]);

